export default __webpack_public_path__ + "static/media/Ballroll_00215.b764caca.png";